module.exports = __webpack_public_path__ + "static/media/maskGroup1.f112c368.png";